import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

export const getTrainingGroupTableColumns = (onAssignTraining: (row: any) => void) => [
  {
    label: "Training Group",
    key: "traininggroup",
    width: "40%",
    type: "link" as const,
    onClick: onAssignTraining,
    tooltip: true,
    maxLength: 60,
  },
  {
    label: "Description",
    key: "description",
    width: "60%",
    tooltip: true,
    maxLength: 100,
  },
];

export const trainingGroupFormFields: FormFieldConfig[] = [
  {
    name: "traininggroup",
    label: "Training Group",
    type: "text",
    placeholder: "Enter Training Group",
    required: true,
    rules: validations.trainingGroup.traininggroup,
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Enter Description",
    required: true,
    rules: validations.trainingGroup.description,
  },
];
